<template>
  <div class="lxn-w100">
    <div class="AcRemoteController-wrapper-lcd lxn-margin-auto lxn-border-round">
      <div class="AcRemoteController-wrapper-mode lxn-float-left lxn-h100">
        <div v-if="modeVisualSettings.show" class="AcRemoteController-mode-icon lxn-margin-auto">
          <ButtonIcon :size="40" bgColor="#52636b" :icon="modeVisualSettings.icon" :iconColor="modeVisualSettings.iconColor" :padding="0" />
        </div>
        <div v-if="modeVisualSettings.show" class="AcRemoteController-mode-text lxn-w100 lxn-text-en lxn-text-center" :style="modeVisualSettings.textStyle">
          {{modeVisualSettings.text}}
        </div>
      </div>
      <div class="AcRemoteController-wrapper-temperature lxn-float-left lxn-h100 lxn-pos-rel">
        <div class="AcRemoteController-fullDigit lxn-w100 lxn-text-center lxn-text-7seg lxn-pos-abs">
          88
        </div>
        <div class="AcRemoteController-temperature lxn-w100 lxn-text-center lxn-text-7seg lxn-pos-abs">
          {{temperatureText}}
        </div>
      </div>
      <div class="AcRemoteController-wrapper-fan lxn-float-left lxn-h100">
        <div v-if="fanVisualSettings.show" class="AcRemoteController-fan-icon lxn-margin-auto">
          <ButtonIcon :size="40" bgColor="#52636b" icon="fan" iconColor="#ceaf5c" :padding="0" />
        </div>
        <div v-if="fanVisualSettings.show" class="AcRemoteController-fan-text lxn-w100 lxn-text-en lxn-text-center">
          {{fanVisualSettings.text}}
        </div>
      </div>
    </div>
    <div class="AcRemoteController-wrapper-buttons lxn-margin-auto lxn-overflow-hidden">
      <div class="AcRemoteController-buttons-col lxn-float-left">
        <div class="AcRemoteController-button-group lxn-circle lxn-margin-auto">
          <div class="AcRemoteController-button lxn-circle lxn-margin-auto" @click="buttonClicked('off')">
            <ButtonIcon :size="70" bgColor="#f76b48" icon="turnOff" iconColor="#ffffff" :padding="10" :isRound="true" borderColor="#f6af9d" :borderWidth="5" :onclickEffect="true" />
          </div>
        </div>
      </div>
      <div class="AcRemoteController-buttons-col lxn-float-left">
        <div class="AcRemoteController-button-group lxn-circle lxn-margin-auto">
          <div class="AcRemoteController-button lxn-circle lxn-margin-auto" @click="buttonClicked('fan')">
            <ButtonIcon :size="70" bgColor="#f0ebe8" icon="fan" iconColor="#51616e" :padding="10" :isRound="true" borderColor="#56c2f0" :borderWidth="5" :onclickEffect="true" />
          </div>
        </div>
        <div style="height: 20px;">
        </div>
        <div class="AcRemoteController-button-group lxn-circle lxn-margin-auto">
          <div class="AcRemoteController-button lxn-circle lxn-margin-auto" @click="buttonClicked('mode')">
            <ButtonIcon :size="70" bgColor="#f0ebe8" icon="mode" iconColor="#51616e" :padding="10" :isRound="true" borderColor="#56c2f0" :borderWidth="5" :onclickEffect="true" />
          </div>
        </div>
      </div>
      <div class="AcRemoteController-buttons-col lxn-float-left">
        <div class="AcRemoteController-button-group2 lxn-margin-auto">
          <div class="AcRemoteController-button lxn-circle lxn-margin-auto" @click="buttonClicked('plus')">
            <ButtonIcon :size="70" bgColor="#f0ebe8" icon="plus" iconColor="#51616e" :padding="10" :isRound="true" borderColor="#56c2f0" :borderWidth="5" :onclickEffect="true" />
          </div>
          <div style="height: 30px;">
          </div>
          <div class="AcRemoteController-button lxn-circle lxn-margin-auto" @click="buttonClicked('minus')">
            <ButtonIcon :size="70" bgColor="#f0ebe8" icon="minus" iconColor="#51616e" :padding="10" :isRound="true" borderColor="#56c2f0" :borderWidth="5" :onclickEffect="true" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonIcon from '@/components/ButtonIcon.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'
import NODE7 from '@/statics/devices/Node7/header.js'

export default {
  name: 'AcRemoteController',
  props: {
    nodeUUID: Number,
    outputIndex: Number,
    sendCommand: Boolean,
  },
  data: function() {
    return {
      node: this.$store.getters.getNodeByUUID(this.nodeUUID),
      targetCommandIndex: 0,
      currentModeIndex: 0,
      currentTemperatureIndex: 0,
      currentFanIndex: 0,
      commandSetTimeoutHandle: -1,
      debounceDelay: 1000,
    }
  },
  components: {
    ButtonIcon
  },
  mounted: function () {
    this.$emit('input', {targetCommandIndex: this.targetCommandIndex, targetMode: this.targetMode, targetTemperature: this.targetTemperature, targetFan: this.targetFan});
  },
  watch: {
    nodeUUID: function (newVal) {
      this.node =this.$store.getters.getNodeByUUID(newVal);
    },
    targetCommandIndex: function (newVal) {
      if(this.sendCommand){
        clearTimeout(this.commandSetTimeoutHandle);
        this.commandSetTimeoutHandle = setTimeout(function () {
          this.$store.commit('setAppBusy', true);
          var messagingHook = new Messaging(new Logger(false));
          messagingHook.init({
            psk: this.hub.psk,
            destinationUUID: this.hub.uuid,
            sourceUUID: this.$store.state.user.uuid
          });
          this.$store.dispatch('setNodesParameters', {
            messagingHook: messagingHook,
            hubUUID: this.hub.uuid,
            nodeUUID: this.node.uuid,
            bodyContent: {
              nodeActions: [
                {
                  nodeUUID: this.node.uuid,
                  actions: [
                    {
                      parameterId: NODE7.IR.PARAMETER_ID,
                      valueOfChange: messagingHook.utility.arrayTo128(this.irDevice.commands[newVal].command),
                      typeOfAction: CONFIGS.ACTION_TYPE_SET,
                      timeDelay: 0
                    }
                  ]
                },
              ]
            }
          })
          .then( () => {
            console.log("Done");
            this.$store.commit('setAppBusy', false);
          })
          .catch( response => {
            if(response.rejectCode == 1){
              this.$router.push('/SettingsNodeError');
            }else if(response.rejectCode == 2){
              this.$router.push('/SettingsHubError');
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
            }
            this.$store.commit('setAppBusy', false);
          });
        }.bind(this), this.debounceDelay);
      }
    },
  },
  computed: {
    hub: function () {
      return this.$store.getters.getHubByUUID(this.node.hubUUID);
    },
    isNodeOffline: function () {
      if(this.node.connectionStatus == 1){
        return false;
      }else{
        return true;
      }
    },
    output: function () {
      return this.node.outputs[this.outputIndex];
    },
    irDevice: function () {
      var irDevice = NODE7.devices[this.output.settings.deviceType].brands[this.output.settings.brand].devices[this.output.settings.model];
      return irDevice;
    },
    targetCommand: function () {
      return this.irDevice.commands[this.targetCommandIndex];
    },
    targetMode: function () {
      return this.targetCommand.mode;
    },
    targetTemperature: function () {
      return this.targetCommand.temperature;
    },
    targetFan: function () {
      return this.targetCommand.fan;
    },
    modeVisualSettings: function () {
      var icon = '';
      var iconColor = '';
      var show = true;
      var text = '';
      var textStyle = '';
      switch(this.targetMode){
        case "AC_MODE_COOL":
          icon = 'cool';
          iconColor = '#319dde';
          text = 'Cool';
          break;
        case "AC_MODE_HEAT":
          icon = 'heat';
          iconColor = '#ffd400';
          text = 'Heat';
          break;
        case "AC_MODE_FAN":
          icon = 'fan2';
          iconColor = '#9ffdff';
          text = 'Fan';
          break;
        case "AC_MODE_AUTO":
          icon = 'auto';
          iconColor = '#ffffff';
          text = 'Auto';
          break;
        case "AC_MODE_DRY":
          icon = 'dry';
          iconColor = '#e4ff9f';
          text = 'Dry';
          break;
        case "AC_MODE_FEEL":
          icon = 'feel';
          iconColor = '#e4ff9f';
          text = 'feel';
          break;
        default:
          show = false;
      }
      textStyle = 'color: ' + iconColor + ';';
      return {icon: icon, iconColor: iconColor, text: text, textStyle: textStyle, show: show};
    },
    fanVisualSettings: function () {
      var show = true;
      var text = '';
      switch(this.targetFan){
        case "AC_FAN_LOW":
          text = 'Low';
          break;
        case "AC_FAN_MID":
          text = 'Mid';
          break;
        case "AC_FAN_HIGH":
          text = 'High';
          break;
        case "AC_FAN_AUTO":
          text = 'Auto';
          break;
        case "AC_FAN_ULTRA_LOW":
          text = 'Ultra Low';
          break;
        default:
          show = false;
      }
      return {text: text, show: show};
    },
    temperatureText: function () {
      switch(this.targetTemperature){
        case "AC_TEMP_16":
          return "16";
        case "AC_TEMP_17":
          return "17";
        case "AC_TEMP_18":
          return "18";
        case "AC_TEMP_19":
          return "19";
        case "AC_TEMP_20":
          return "20";
        case "AC_TEMP_21":
          return "21";
        case "AC_TEMP_22":
          return "22";
        case "AC_TEMP_23":
          return "23";
        case "AC_TEMP_24":
          return "24";
        case "AC_TEMP_25":
          return "25";
        case "AC_TEMP_26":
          return "26";
        case "AC_TEMP_27":
          return "27";
        case "AC_TEMP_28":
          return "28";
        case "AC_TEMP_29":
          return "29";
        case "AC_TEMP_30":
          return "30";
        case "AC_TEMP_31":
          return "31";
        case "AC_TEMP_32":
          return "32";
        case "AC_TEMP_LOW":
          return "Lo";
        case "AC_TEMP_HIGH":
          return "Hi";
        case "AC_TEMP_MID":
          return "Mi";
        case "AC_TEMP_DRY_7":
          return "07";
        case "AC_TEMP_DRY_6":
          return "06";
        case "AC_TEMP_DRY_5":
          return "05";
        case "AC_TEMP_DRY_4":
          return "04";
        case "AC_TEMP_DRY_3":
          return "03";
        case "AC_TEMP_DRY_2":
          return "02";
        case "AC_TEMP_DRY_1":
          return "01";
        case "AC_TEMP_DRY_N1":
          return "-1";
        case "AC_TEMP_DRY_N2":
          return "-2";
        case "AC_TEMP_DRY_N3":
          return "-3";
        case "AC_TEMP_DRY_N4":
          return "-4";
        case "AC_TEMP_DRY_N5":
          return "-5";
        case "AC_TEMP_DRY_N6":
          return "-6";
        case "AC_TEMP_DRY_N7":
          return "-7";
        case "AC_TEMP_AUTO_1":
          return "01";
        case "AC_TEMP_AUTO_2":
          return "02";
        case "AC_TEMP_AUTO_3":
          return "03";
        case "AC_TEMP_AUTO_N1":
          return "-1";
        case "AC_TEMP_AUTO_N2":
          return "-2";
        case "AC_TEMP_AUTO_N3":
          return "-3";
        default:
          return "";
      }
    },
    modes: function () {
      var modes = [];
      for(var i = 0; i < this.irDevice.commands.length; i++){
        if(modes.indexOf(this.irDevice.commands[i].mode) == -1 && this.irDevice.commands[i].mode != "AC_MODE_OFF"){
          modes.push(this.irDevice.commands[i].mode);
        }
      }
      return modes;
    },
  },
  methods: {
    temperaturesInMode: function (mode) {
      var temperaturesInMode = [];
      for(var i = 0; i < this.irDevice.commands.length; i++){
        if(this.irDevice.commands[i].mode == mode){
          if(temperaturesInMode.indexOf(this.irDevice.commands[i].temperature) == -1){
            temperaturesInMode.push(this.irDevice.commands[i].temperature);
          }
        }
      }
      return temperaturesInMode;
    },
    fansInMode: function (mode) {
      var fansInMode = [];
      for(var i = 0; i < this.irDevice.commands.length; i++){
        if(this.irDevice.commands[i].mode == mode){
          if(fansInMode.indexOf(this.irDevice.commands[i].fan) == -1){
            fansInMode.push(this.irDevice.commands[i].fan);
          }
        }
      }
      return fansInMode;
    },
    findCommandIndex: function (mode, temperature, fan) {
      for(var i = 0; i < this.irDevice.commands.length; i++){
        var command = this.irDevice.commands[i];
        if(command.mode == mode && command.temperature == temperature && command.fan == fan){
          return i;
        }
      }
      return -1;
    },
    buttonClicked: function (button) {
      if(button == 'off'){
        if(this.targetCommandIndex == 0){
          this.targetCommandIndex = this.irDevice.defaultCommandIndex;
          this.currentTemperatureIndex = 0;
          this.currentFanIndex = 0;
          this.currentModeIndex = 0;
        }else{
          this.targetCommandIndex = 0;
        }
      }else if(button == 'plus' && this.targetCommandIndex != 0){
        var nextTemperatureIndex = this.currentTemperatureIndex + 1;
        if(nextTemperatureIndex >= this.temperaturesInMode(this.targetMode).length){
          return;
        }else{
          var mode = this.targetMode;
          var temperature = this.temperaturesInMode(mode)[nextTemperatureIndex];
          var fan = this.targetFan;
          var commandIndex = this.findCommandIndex(mode, temperature, fan);
          if(commandIndex != -1){
            this.currentTemperatureIndex = nextTemperatureIndex;
            this.targetCommandIndex = commandIndex;
          }else{
            return;
          }
        }
      }else if(button == 'minus' && this.targetCommandIndex != 0){
        nextTemperatureIndex = this.currentTemperatureIndex - 1;
        if(nextTemperatureIndex < 0){
          return;
        }else{
          mode = this.targetMode;
          temperature = this.temperaturesInMode(mode)[nextTemperatureIndex];
          fan = this.targetFan;
          commandIndex = this.findCommandIndex(mode, temperature, fan);
          if(commandIndex != -1){
            this.currentTemperatureIndex = nextTemperatureIndex;
            this.targetCommandIndex = commandIndex;
          }else{
            return;
          }
        }
      }else if(button == 'fan' && this.targetCommandIndex != 0){
        var nextFanIndex = this.currentFanIndex + 1;
        if(nextFanIndex >= this.fansInMode(this.targetMode).length){
          nextFanIndex = 0;
        }
        mode = this.targetMode;
        temperature = this.targetTemperature;
        fan = this.fansInMode(mode)[nextFanIndex];
        commandIndex = this.findCommandIndex(mode, temperature, fan);
        if(commandIndex != -1){
          this.currentFanIndex = nextFanIndex;
          this.targetCommandIndex = commandIndex;
        }else{
          return;
        }
      }else if(button == 'mode' && this.targetCommandIndex != 0){
        var nextModeIndex = this.currentModeIndex + 1;
        if(nextModeIndex >= this.modes.length){
          nextModeIndex = 0;
        }
        temperature = this.targetTemperature;
        fan = this.targetFan;
        mode = this.modes[nextModeIndex];
        commandIndex = this.findCommandIndex(mode, temperature, fan);
        if(commandIndex != -1){
          this.currentModeIndex = nextModeIndex;
          this.currentTemperatureIndex = this.temperaturesInMode(mode).indexOf(temperature);
          this.currentFanIndex = this.fansInMode(mode).indexOf(fan);
          this.targetCommandIndex = commandIndex;
        }else{
          this.currentTemperatureIndex = 0;
          this.currentFanIndex = 0;
          temperature = this.temperaturesInMode(mode)[this.currentTemperatureIndex];
          fan = this.fansInMode(mode)[this.currentFanIndex];
          commandIndex = this.findCommandIndex(mode, temperature, fan);
          if(commandIndex != -1){
            this.currentModeIndex = nextModeIndex;
            this.targetCommandIndex = commandIndex;
          }else{
            return;
          }
        }
      }
      this.$emit('input', {targetCommandIndex: this.targetCommandIndex, targetMode: this.targetMode, targetTemperature: this.targetTemperature, targetFan: this.targetFan});
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .AcRemoteController-wrapper-lcd {
    width: calc(100% - 28px);
    height: 100px;
    background-color: #52636b;
    border-style: solid;
    border-width: 4px;
    border-color: #c8c9cb;
  }
  .AcRemoteController-wrapper-mode {
    width: 25%;
  }
  .AcRemoteController-wrapper-temperature {
    width: 50%;
  }
  .AcRemoteController-wrapper-fan {
    width: 25%;
  }
  .AcRemoteController-fullDigit {
    top: 0;
    left: 0;
    line-height: 100px;
    color: #6e7c85;
    font-size: 70px;
  }
  .AcRemoteController-temperature {
    top: 0;
    left: 0;
    line-height: 100px;
    color: #a1d0ec;
    font-size: 70px;
  }
  .AcRemoteController-mode-icon {
    margin-top: 15px;
    width: 40px;
    height: 40px;
  }
  .AcRemoteController-mode-text {
    margin-top: 5px;
  }
  .AcRemoteController-fan-icon {
    margin-top: 15px;
    width: 40px;
    height: 40px;
  }
  .AcRemoteController-fan-text {
    margin-top: 5px;
    color: #ceaf5c;
  }
  .AcRemoteController-wrapper-buttons {
    width: calc(100% - 28px);
    margin-top: 30px;
    margin-bottom: 20px;
  }
  .AcRemoteController-buttons-col {
    width: 33%;
  }
  .AcRemoteController-button {
    width: 70px;
    height: 70px;
  }
  .AcRemoteController-button-group {
    width: 80px;
    height: 80px;
    padding: 5px;
    background-color: #dedede;
  }
  .AcRemoteController-button-group2 {
    width: 80px;
    padding: 5px;
    background-color: #dedede;
    border-radius: 40px;
  }
</style>
